import { TableRow, TableCell, Typography } from '@mui/material';
import { VyTooltip } from '../../../../../../components/new-design/VyTooltip';
import type { Currency } from '@vy/types';
import { DISCOUNT_MODELS, type DiscountConfiguration } from '@vy/types';
import { Price } from '../../../../../../components/design/Price';

type DiscountTableRowProps = {
  discountConfiguration: DiscountConfiguration;
  currency: Currency;
};

export const DiscountTableRow: React.FC<DiscountTableRowProps> = ({ currency, discountConfiguration }) => {
  const amount = discountConfiguration.amountToDeduct;

  return (
    <TableRow
      sx={{
        '&:last-child td, &:last-child th': {
          borderBottom: 0,
        },
        'td, th': {
          position: 'relative',
        },
      }}
    >
      <TableCell component="th" scope="row" className="px-0 py-2">
        <VyTooltip tooltipContent={discountConfiguration.name} placement="top" arrow>
          <Typography
            className="truncate"
            sx={{
              fontSize: "13px",
              fontWeight: 500,
              lineHeight: "22px",
              color: "text.secondary"
            }}>
            {`Discount - ${discountConfiguration.name}`}
          </Typography>
        </VyTooltip>
      </TableCell>
      <TableCell component="th" scope="row" className="px-0 py-2" />
      <TableCell component="th" scope="row" className="px-0 py-2" />
      <TableCell className="px-0 py-2" align="right">
        {discountConfiguration.type === DISCOUNT_MODELS.FIXED ? (
          <Price
            currency={currency}
            align="right"
            color="text.secondary"
            sx={{
              fontSize: '13px',
              fontWeight: 500,
              lineHeight: '22px',
            }}
            className="w-full"
          >
            {`-${amount}`}
          </Price>
        ) : (
          <Typography
            sx={{
              color: "text.secondary",
              fontSize: "13px",
              fontWeight: 500,
              lineHeight: "22px"
            }}>
            {`-${amount}%`}
          </Typography>
        )}
      </TableCell>
    </TableRow>
  );
};
